export default "__VITE_ASSET__C1sQGBbI__"